The candidate's responses to the application's questionnaire.
